import * as types from './constants';

// Send Unmasking Invitation Bulk
export const sendUnmaskingInvitationBulkRequest = data => (
  { type: types.SEND_UNMASKING_INVITATION_BULK_REQUEST, payload: data }
);

export const sendUnmaskingInvitationBulkDone = data => (
  { type: types.SEND_UNMASKING_INVITATION_BULK_DONE, payload: data }
);

export const sendUnmaskingInvitationBulkFailed = errors => (
  { type: types.SEND_UNMASKING_INVITATION_BULK_FAILED, payload: errors }
);

export const sendUnmaskingInvitationBulkReset = () => (
  { type: types.SEND_UNMASKING_INVITATION_BULK_RESET }
);